import React from "react";
import "./../HairSubService.css"

const DandruffTreatmentHow = () => {
  return (
    <div className="hairSubServiceWhat">
      <h3>How Our Treatments Work</h3>
      <li>
        <h6> 1. Consultation:</h6>
        <p>
          Begin with an in-depth consultation to understand your scalp condition
          and lifestyle.
        </p>
      </li>
      <li>
        <h6> 2. Diagnosis:</h6>
        <p>
          Our experts perform a detailed scalp analysis to identify the type and
          severity of dandruff.
        </p>
      </li>
      <li>
        <h6> 3. Customized Plan:</h6>
        <p>
          Based on the findings, we design a tailored treatment plan that
          includes in-salon services and at-home care recommendations.
        </p>
      </li>
      <li>
        <h6> 4. Treatment Sessions:</h6>
        <p>
          Experience our professional treatments, combining advanced techniques
          with premium products.
        </p>
      </li>
      <li>
        <h6> 5. Follow-Up:</h6>
        <p>
          Regular check-ins ensure that your scalp is responding positively to
          the treatment, with adjustments made as necessary.
        </p>
      </li>
    </div>
  );
};

export default DandruffTreatmentHow;
